import { render, staticRenderFns } from "./FiltroSelecaoCultura.vue?vue&type=template&id=66791192&scoped=true&lang=pug"
import script from "./FiltroSelecaoCultura.vue?vue&type=script&lang=js"
export * from "./FiltroSelecaoCultura.vue?vue&type=script&lang=js"
import style0 from "./FiltroSelecaoCultura.vue?vue&type=style&index=0&id=66791192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66791192",
  null
  
)

export default component.exports